import { Dispatch, SetStateAction, useState } from 'react';
import {
  ChakraBox,
  ChakraFlex,
  ChakraSwitch,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';
import EditNoteAccordion from '~/components/maud/patients/note/EditNoteAccordion';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';

const { label, labelBold } = EquipUITheme.typography;

type Props = {
  noteExternalId: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const PatientNoteItemAddAddendumSection = ({
  noteExternalId,
  setIsOpen,
}: Props) => {
  const { currentPatientId } = useGlobalContext();
  const TOP_LEVEL_ID = `patient-note-item__${noteExternalId}`;
  const [isEditAttributesEnabled, setIsEditAttributesEnabled] =
    useState<boolean>(false);

  return (
    <>
      <ChakraBox id={`${TOP_LEVEL_ID}__add-addendum-modal`} marginBottom="24px">
        <ChakraText
          {...labelBold}
          id={`${TOP_LEVEL_ID}__add-addendum-label`}
          marginTop="24px"
        >
          Add addendum
        </ChakraText>

        <ChakraFlex
          id={`${TOP_LEVEL_ID}__edit-attributes-container`}
          marginBottom="17px"
          marginTop="17px"
          overflowY="visible"
          position="relative"
        >
          <ChakraSwitch
            colorScheme="teal"
            id={`${TOP_LEVEL_ID}__edit-attributes-switch`}
            isChecked={isEditAttributesEnabled}
            onChange={() =>
              setIsEditAttributesEnabled(!isEditAttributesEnabled)
            }
            size="sm"
          />
          <ChakraText
            fontSize="14px"
            id={`${TOP_LEVEL_ID}__edit-attributes-label`}
            lineHeight="17px"
            marginLeft="8px"
            {...label}
          >
            Edit attributes
          </ChakraText>
        </ChakraFlex>
      </ChakraBox>
      <EditNoteAccordion
        appointmentDetails={null}
        dismissAccordion={() => {
          setIsOpen(false);
          setIsEditAttributesEnabled(false);
        }}
        existingNoteId={noteExternalId}
        isAddendumModal
        isEditAttributesEnabled={isEditAttributesEnabled}
        patientId={currentPatientId}
      />
    </>
  );
};
